import { render } from "./support.ja.vue?vue&type=template&id=e2a315a0"
import script from "./support.ja.vue?vue&type=script&lang=js"
export * from "./support.ja.vue?vue&type=script&lang=js"

import "./support.ja.vue?vue&type=style&index=0&id=e2a315a0&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__